import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { errorsMapping } from '../../../constants/errors.js';
import { CANCEL_ANONYMOUS_SUBSCRIPTION } from '../../../operations/mutations/cancel-anonymous-subscription.js';
import '../../../operations/mutations/cancel-subscription.js';

const useCancelAnonymousSubscription = ({ onError , onCompleted ,  } = {})=>{
    const handleOnCompleted = React.useCallback((responseData)=>{
        if (responseData.cancelAnonymousSubscription) {
            var ref;
            const response = responseData.cancelAnonymousSubscription;
            if ('result' in response) {
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted('MUTATION');
            }
            if ('failures' in response && ((ref = response.failures) === null || ref === void 0 ? void 0 : ref.length)) {
                response.failures.forEach((failure)=>{
                    switch(failure === null || failure === void 0 ? void 0 : failure.__typename){
                        case 'SubscriptionNotFoundFailure':
                            console.error('Failed to cancel subscription due to invalid subscription number');
                            toast.failed(errorsMapping.SUBSCRIPTION_NOT_FOUND);
                            break;
                        case 'UnauthorizedFailure':
                            console.error('Invalid credentials provided for cancelling subscription');
                            toast.failed(errorsMapping.SUBSCRIPTION_UNAUTHORIZED);
                            break;
                        case 'InvalidTerminationDateFailure':
                            console.error('Invalid termination date provided');
                            toast.failed(errorsMapping.SUBSCRIPTION_INVALID_TERMINATION_DATE);
                            break;
                        case 'InvalidInputFailure':
                            console.error('Invalid input provided');
                            toast.failed(errorsMapping.SUBSCRIPTION_INVALID_INPUT);
                            break;
                    }
                });
            }
        }
    }, [
        onCompleted
    ]);
    const handleOnError = React.useCallback((e)=>{
        console.error(e);
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'MUTATION'
        });
        // General error for apollo error response
        toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
    }, [
        onError
    ]);
    const [cancel, { loading: isUpdating , error: error , called: isCalled  }] = useMutation(CANCEL_ANONYMOUS_SUBSCRIPTION, {
        onCompleted: handleOnCompleted,
        onError: handleOnError
    });
    const cancelAnonymousSubscription = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(subscriptionNumber, details) {
            yield cancel({
                variables: {
                    subscriptionId: subscriptionNumber,
                    details
                },
                context: {
                    timeout: 30000
                }
            });
        });
        return function(subscriptionNumber, details) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cancel
    ]);
    return {
        isCalled,
        isUpdating,
        error,
        cancelAnonymousSubscription
    };
};

export { useCancelAnonymousSubscription };
//# sourceMappingURL=use-cancel-anonymous-subscription.js.map
